<template>
  <div class="content">
    <div class="row">
      <center>
        <br />
        <br />
        <img :src="`https://photos.teleportal.net/${name}`" class="img" />
        <br />
        <p>
          <router-link to="/gallery">BACK TO GALLERY</router-link> |
          <a :href="`https://photos.teleportal.net/${name}`" target="_blank"
            >DOWNLOAD PHOTO</a
          >
        </p>
        <br />
      </center>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageOne",
  props: {},
  data() {
    return {
      name: ""
    };
  },
  methods: {
    load() {
      if (this.$route.params.name) {
        this.name = this.$route.params.name;
      }
    }
  },
  computed: {},
  created: function() {
    this.load();
  }
};
</script>

<style scoped>
.img {
  width: 80%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.row {
  width: 100%;
}
.col {
  width: 33.3%;
  display: contents;
}
.content {
  text-align: center;
  color: #42b983;
  margin-top: 5vw;
}
</style>
